module.exports = __webpack_public_path__ + "assets1775130923925/img/home-bg.ce61ad56.png";